var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notification)?_c('section',{staticClass:"notification-bar"},[_c('p',[_vm._v(_vm._s(_vm.notification))]),_c('img',{attrs:{"src":require("@/assets/close.svg")},on:{"click":function($event){return _vm.close()}}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }